import Vue from "vue";
import VueRouter from "vue-router";
import Vuelidate from "vuelidate";
import PortalVue from "@linusborg/vue-simple-portal";
import App from "./App.vue";
import {
  InitDirectives,
  redirectToSigninIfTokenExpires,
  addTranslations,
} from "@agyletime/wfm-vue-common";
import "@playvox/almendra-components/dist/assets/fonts/almendra-icons/css/almendra-icons.css";
import "@playvox/almendra-components/dist/almendra.css";
import "@playvox/almendra-components/dist/assets/styles/main.lite.scss";
import routes from "./config/routes";
import translations from "./config/translations";
import { LicenseManager } from "ag-grid-enterprise";

Vue.config.productionTip = false;

redirectToSigninIfTokenExpires();

InitDirectives(Vue);

addTranslations(translations);

// Routing
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: "/capacity_planner",
  routes,
});

// Vue model validation
Vue.use(Vuelidate);

// Toaster/notifications
Vue.use(PortalVue);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

LicenseManager.setLicenseKey(
  "CompanyName=Agyle Time,LicensedApplication=Agyle Time,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=5,LicensedProductionInstancesCount=1,AssetReference=AG-015168,ExpiryDate=28_May_2022_[v2]_MTY1MzY5MjQwMDAwMA==5b7c4acd75cce32c4aa3acec0c624e77"
);
